var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-icon',{attrs:{"icon":"envelope"}}),_vm._v(" "+_vm._s(_vm.data.msg))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }